var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex align-items-center justify-content-center",
      style: _vm.styles,
    },
    [_c("i", { staticClass: "fas fa-circle-notch fa-spin" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }